import { useState, useContext, useTransition, useActionState, startTransition, useOptimistic } from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import styled from "@emotion/styled";

import CookieContext from "../contexts/CookieContext";
import AppContext from "../contexts/AppContext";

const React19 = () => {
  const { apiUserHost, } = useContext(AppContext);
  const { cookies } = useContext(CookieContext);
  const { apiHost } = useContext(AppContext);
  const basePath = 'latencytime/';


  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);

  const [displayValue, runAction, isPending] = useActionState(
    async() => {
      addOptimistic('更新中');

      const response = await fetch(apiHost + basePath, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        },
        // body: JSON.stringify({displayValue}),
      });

      const jsonResponse = await response.json()

      return jsonResponse.get_connected_datetime;
    },
    0
  );

  const [optimisticDisplayValue, addOptimistic] = useOptimistic(
    displayValue,
    (currentDisplayValue, optimisticValue) => {
      return optimisticValue;
    },
  );

  console.log(
    "🚀 ~ App ~ isPending:",
    isPending,
    "\noptimisticDisplayValue:",
    optimisticDisplayValue,
    "\ndisplayValue:",
    displayValue,
  );


  const handlePost = () => {
    startTransition(() => {
      runAction();
    });
  }

const StyledButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #e58123)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;


  const handleClose = () => {
    setOpen(false);
  }

  const handleClick = () => {
    setOpen(true);

    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
        // body: JSON.stringify({responseJSON: responseJSON})
      };

      // const response = await fetch(apiHost + basePath, {headers});
      startTransition(async () => {
        // await fetch('http://127.0.0.1:8000/latencytime/', {headers});
        const response = await fetch(apiHost + basePath, {headers});

        // await fetch(apiHost + basePath, {headers});
        setCount(count => count + 1);

        // alert(response.status)

        if (response.status === 200) {
          const data = await response.json();
          // alert(response.status)
          alert(data.get_connected_datetime)
        }
        else if (response.status === 401) {
          alert(response.status)
        }
        else {
          alert(response.status)
        }
      });
  

      // setLoading(false);

    } catch (err) {
      console.log(err);
    }

  };

  return (
    <>
      <div>React19</div>
        <div>
        {count}
        {/* {responseJson} */}
        <button
          type="button"
          onClick={handleClick}
          disabled={isPending}
        >
          Increment{isPending}
        </button>
        <button
          type="button"
          onClick={handlePost}
          disabled={isPending}
        >
          ++++++{optimisticDisplayValue}
        </button>
        <Dialog
          open={open}
          onClose={handleClose}
          // aria-labelledby="alert-dialog-title"
          // aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="dialog-title">
          Titleです
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="dialog-description">
            メッセージです
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={handleClose} autoFocus>OK</StyledButton>
        </DialogActions>
        </Dialog>

      </div>
    </>
  )
}
export default React19
















